export default {
      id: "arrow-usage",
      viewBox: "0 0 8 8",
      url: __webpack_public_path__ + "sprite.1789552432127.svg#arrow-usage",
      toString: function () {
        return this.url;
      }
    }